import Button from '@/decodo/components/atoms/Button';
import AnimatedEl from '@/lib/motion';
import { cn } from '@/lib/utils';

export interface Tab<T extends string> {
  value: T;
  label: string;
  content: React.ReactNode;
}

export type TabProps<T extends string> = {
  tab: Tab<T>;
  isActive: boolean;
  classNames?: {
    tab?: string;
    selectionBar?: string;
  };
  onClick: (tab: Tab<T>) => void;
};

export function Tab<T extends string>({
  tab,
  isActive,
  classNames,
  onClick,
}: TabProps<T>) {
  return (
    <li className='relative'>
      <Button
        noStyles
        role='tab'
        data-tracker-type='tab'
        data-tracker-context={tab.value}
        data-tab={tab.value}
        aria-selected={isActive}
        aria-controls={`tabpanel-${tab.value}`}
        className={cn(
          'text-body-l-medium hover:text-brand-500 focus-visible:ring-brand-500 relative whitespace-nowrap border-none px-3 py-2 font-serif transition-colors duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-50',
          isActive && 'text-brand-500',
          classNames?.tab
        )}
        onClick={() => onClick(tab)}
      >
        {tab.label}
      </Button>
      {isActive && (
        <AnimatedEl
          el='div'
          aria-hidden
          className='bg-brand-500 absolute bottom-0 left-0 h-[2px] w-full rounded-sm'
          layoutId='underline'
        />
      )}
    </li>
  );
}
